import { getJsonRequest } from '@chilecompra/react-kit/requests'
import { REACT_APP_API_BASE_URL } from '../config/settings/environment'
import factoryAuthService from '../modules/requests/services'

/**
 * Gets amounts of the year by a yearly distribution.
 */
export const getSmallerCompaniesSectors = factoryAuthService(({ year, sector }) =>
  getJsonRequest(`${REACT_APP_API_BASE_URL}/v1/empresasMenorTamanio/montos/cantidad/mensual/${year}/${sector}`)
)

/**
 * Gets compared amounts of smaller companies by sector.
 */
export const getSmallerCompaniesCompared = factoryAuthService(({ sector }) =>
  getJsonRequest(`${REACT_APP_API_BASE_URL}/v1/empresasMenorTamanio/montos/cantidad/participacion/${sector}`)
)
/***
 * Gets Participation of smaller companies
 */
export const getSmallerCompaniesParticipation = factoryAuthService(() =>
  getJsonRequest(`${REACT_APP_API_BASE_URL}/v1/empresasMenorTamanio/montos/cantidad/participacionTotal`)
)
